module.exports = __webpack_public_path__ + "static/device_phone_android_dark-847f3eac829afce216819a92254d42bf.png";